export default {
  tooltip: 1080,
  dateSelector: 1070,
  notification: 1060,
  modal: 1050,
  overlay: 1040,
  panel: 1030
};
//# sourceMappingURL=zIndex.js.map